import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/login'),
      meta: {
        title: "登录页面"
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/view/register'),
      meta: {
        title: "注册页面"
      }
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('@/view/register/forgetPwd'),
      meta: {
        title: "忘记密码"
      }
    },
    {
      path: '/',
      name: 'homePage',
      component: () => import('@/view/home'),
      children: [{
        path: '/',
        name: '/',
        component: () => import('@/view/home/homePage'),
        meta: {
          title: "首页",
          name: 'home'
        }
      }, {
        path: '/listing',
        name: '/listing',
        component: () => import('@/view/home/listing'),
        meta: {
          title: "挂牌",
          name: 'listing'
        }
      }, {
        path: '/listingDetail',
        name: '/listingDetail',
        component: () => import('@/view/home/listing/detail'),
        meta: {
          title: "挂牌详情",
          name: 'listing'
        }
      }, {
        path: '/bidding',
        name: '/bidding',
        component: () => import('@/view/home/bidding'),
        meta: {
          title: "竞价",
          name: 'bidding'
        }

      }, {
        path: '/biddingDetail',
        name: '/biddingDetail',
        component: () => import('@/view/home/bidding/detail'),
        meta: {
          title: "竞价详情",
          name: 'bidding'
        }
      }, {
        path: '/rules',
        name: '/rules',
        component: () => import('@/view/home/rules'),
        meta: {
          title: "交易规则",
          name: 'rules'
        }
      }, {
        path: '/detail',
        name: '/detail',
        component: () => import('@/view/home/rules/detail'),
        meta: {
          title: "交易规则",
          name: 'rules'
        }
      }, {
        path: '/about',
        name: '/about',
        component: () => import('@/view/home/about'),
        meta: {
          title: "关于我们",
          name: 'about'
        }
      }, {
        path: '/usercenter',
        name: '/usercenter',
        component: () => import('@/view/home/usercenter'),
        meta: {
          title: "个人中心",
          name: 'usercenter',
          requiresAuth: true
        },
        children: [
          {
            path: '',
            name: 'base',
            component: () => import('@/view/home/usercenter/base'),
            meta: {
              title: "基本信息",
              name: 'base',
              requiresAuth: true
            }
          },
          {
            path: 'apply',
            name: 'apply',
            component: () => import('@/view/home/usercenter/apply'),
            meta: {
              title: "我的报名",
              name: 'apply',
              requiresAuth: true
            }
          },
          {
            path: 'bidding',
            name: 'bidding',
            component: () => import('@/view/home/usercenter/bidding'),
            meta: {
              title: "我的竞价",
              name: 'bidding',
              requiresAuth: true
            }
          },
        ]
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js